import { connect } from "react-redux"

import { dashboardKnowledgeInvalidationRequest } from "../../../actions/dashboard-actions"

import KnowledgeListWidget from "../../common/knowledge-list/KnowledgeListWidget"
import DashboardKnowledgeListContainer from "./DashboardKnowledgeListContainer"

const mapStateToProps = ({ presentation: { dashboard }, paging }) => ({
    knowledgeListContainerComponent: DashboardKnowledgeListContainer,
    isFetching: dashboard.isFetchingList,
    pagingRequest: paging.moderationFeed[dashboard.searchCriteria]
})

const mapDispatchToProps = dispatch => ({
    invalidate: pagingRequest => () =>
        dispatch(dashboardKnowledgeInvalidationRequest(pagingRequest))
})

export default connect(mapStateToProps, mapDispatchToProps)(KnowledgeListWidget)
